<template>
	<div class="px-3 py-2 flex items-end gap-3" @click.stop="emit('stopEditing')">
		<template v-if="module.image">
			<FileManager v-if="showFileManager" :id="`module-${module.id}-image-file-manager`" v-model:selected-file="module.image.file" @close="showFileManager = false"/>
			<PrimaryButton :color="Color.Blue" @click.stop="showFileManager = true">
				<i class="fa-solid fa-image"/>
			</PrimaryButton>
		</template>
		<LabeledObject v-if="module.qr">
			<template #label>{{ trans('certificate.tools.qr.title') }}</template>
			<select v-model="module.qr.code">
				<option :value="true">{{ trans('certificate.tools.qr.code') }}</option>
				<option :value="false">{{ trans('certificate.tools.qr.link') }}</option>
			</select>
		</LabeledObject>
		<template v-if="module.cell">
			<PrimaryButton v-if="module.cell.bold" :color="Color.Gray" @click.stop="module.cell.bold = false">
				<i class="fa-solid fa-bold"/>
			</PrimaryButton>
			<SecondaryButton v-else :color="Color.Gray" @click.stop="module.cell.bold = true">
				<i class="fa-solid fa-bold"/>
			</SecondaryButton>
			<PrimaryButton v-if="module.cell.italic" :color="Color.Gray" @click.stop="module.cell.italic = false">
				<i class="fa-solid fa-italic"/>
			</PrimaryButton>
			<SecondaryButton v-else :color="Color.Gray" @click.stop="module.cell.italic = true">
				<i class="fa-solid fa-italic"/>
			</SecondaryButton>
			<PrimaryButton v-if="module.cell.underlined" :color="Color.Gray" @click.stop="module.cell.underlined = false">
				<i class="fa-solid fa-underline"/>
			</PrimaryButton>
			<SecondaryButton v-else :color="Color.Gray" @click.stop="module.cell.underlined = true">
				<i class="fa-solid fa-underline"/>
			</SecondaryButton>

			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.align.title') }}</template>
				<div class="flex items-end gap-3">
					<PrimaryButton v-if="module.cell.align === CertificateAlignment.Left" :color="Color.Gray">
						<i class="fa-solid fa-align-left"/>
					</PrimaryButton>
					<SecondaryButton v-else :color="Color.Gray" @click.stop="module.cell.align = CertificateAlignment.Left">
						<i class="fa-solid fa-align-left"/>
					</SecondaryButton>
					<PrimaryButton v-if="module.cell.align === CertificateAlignment.Center" :color="Color.Gray">
						<i class="fa-solid fa-align-center"/>
					</PrimaryButton>
					<SecondaryButton v-else :color="Color.Gray" @click.stop="module.cell.align = CertificateAlignment.Center">
						<i class="fa-solid fa-align-center"/>
					</SecondaryButton>
					<PrimaryButton v-if="module.cell.align === CertificateAlignment.Right" :color="Color.Gray">
						<i class="fa-solid fa-align-right"/>
					</PrimaryButton>
					<SecondaryButton v-else :color="Color.Gray" @click.stop="module.cell.align = CertificateAlignment.Right">
						<i class="fa-solid fa-align-right"/>
					</SecondaryButton>
				</div>
			</LabeledObject>

			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.font.title') }}</template>
				<select v-model="module.cell.font">
					<option value="courier">Courier</option>
					<option value="helvetica">Helvetica</option>
					<option value="symbol">Symbol</option>
					<option value="times">Times New Roman</option>
					<option value="zapfdingbats">Zapf Dingbats</option>
				</select>
			</LabeledObject>
			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.font_size') }}</template>
				<input v-model="module.cell.font_size" type="number" min="8" step="1" max="96">
			</LabeledObject>
			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.color') }}</template>
				<label class="px-2 py-1 bg-gray-50 dark:bg-gray-900 rounded border border-gray-200 dark:border-gray-800 relative" for="cell-color">
					<i class="fa-solid fa-font" :style="`color: ${module.cell.color} !important;`"/>
					<input id="cell-color" v-model="module.cell.color" type="color" class="absolute top-0 left-0 right-0 bottom-0 size-full -z-10">
				</label>
			</LabeledObject>
		</template>
		<template v-else-if="module.qr && !module.qr.code">
			<PrimaryButton v-if="module.qr.bold" :color="Color.Gray" @click.stop="module.qr.bold = false">
				<i class="fa-solid fa-bold"/>
			</PrimaryButton>
			<SecondaryButton v-else :color="Color.Gray" @click.stop="module.qr.bold = true">
				<i class="fa-solid fa-bold"/>
			</SecondaryButton>
			<PrimaryButton v-if="module.qr.italic" :color="Color.Gray" @click.stop="module.qr.italic = false">
				<i class="fa-solid fa-italic"/>
			</PrimaryButton>
			<SecondaryButton v-else :color="Color.Gray" @click.stop="module.qr.italic = true">
				<i class="fa-solid fa-italic"/>
			</SecondaryButton>
			<PrimaryButton v-if="module.qr.underlined" :color="Color.Gray" @click.stop="module.qr.underlined = false">
				<i class="fa-solid fa-underline"/>
			</PrimaryButton>
			<SecondaryButton v-else :color="Color.Gray" @click.stop="module.qr.underlined = true">
				<i class="fa-solid fa-underline"/>
			</SecondaryButton>

			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.align.title') }}</template>
				<div class="flex items-end gap-3">
					<PrimaryButton v-if="module.qr.align === CertificateAlignment.Left" :color="Color.Gray">
						<i class="fa-solid fa-align-left"/>
					</PrimaryButton>
					<SecondaryButton v-else :color="Color.Gray" @click.stop="module.qr.align = CertificateAlignment.Left">
						<i class="fa-solid fa-align-left"/>
					</SecondaryButton>
					<PrimaryButton v-if="module.qr.align === CertificateAlignment.Center" :color="Color.Gray">
						<i class="fa-solid fa-align-center"/>
					</PrimaryButton>
					<SecondaryButton v-else :color="Color.Gray" @click.stop="module.qr.align = CertificateAlignment.Center">
						<i class="fa-solid fa-align-center"/>
					</SecondaryButton>
					<PrimaryButton v-if="module.qr.align === CertificateAlignment.Right" :color="Color.Gray">
						<i class="fa-solid fa-align-right"/>
					</PrimaryButton>
					<SecondaryButton v-else :color="Color.Gray" @click.stop="module.qr.align = CertificateAlignment.Right">
						<i class="fa-solid fa-align-right"/>
					</SecondaryButton>
				</div>
			</LabeledObject>

			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.font.title') }}</template>
				<select v-model="module.qr.font">
					<option value="courier">Courier</option>
					<option value="helvetica">Helvetica</option>
					<option value="symbol">Symbol</option>
					<option value="times">Times New Roman</option>
					<option value="zapfdingbats">Zapf Dingbats</option>
				</select>
			</LabeledObject>
			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.font_size') }}</template>
				<input v-model="module.qr.font_size" type="number" min="8" step="1" max="96">
			</LabeledObject>
			<LabeledObject>
				<template #label>{{ trans('certificate.tools.cell.color') }}</template>
				<label class="px-2 py-1 bg-gray-50 dark:bg-gray-900 rounded border border-gray-200 dark:border-gray-800 relative" for="qr-color">
					<i class="fa-solid fa-font" :style="`color: ${module.qr.color} !important;`"/>
					<input id="qr-color" v-model="module.qr.color" type="color" class="absolute top-0 left-0 right-0 bottom-0 size-full -z-10">
				</label>
			</LabeledObject>
		</template>
		<LabeledObject>
			<template #label>
				<i class="fa-solid fa-long-arrow-alt-right"/>
				{{ trans('certificate.modules.props.left') }}
			</template>
			<input v-model="module.x" type="number" min="0" step="1" :max="maxWidth - module.w">
		</LabeledObject>
		<LabeledObject>
			<template #label>
				<i class="fa-solid fa-long-arrow-alt-down"/>
				{{ trans('certificate.modules.props.top') }}
			</template>
			<input v-model="module.y" type="number" min="0" step="1" :max="maxHeight - module.h">
		</LabeledObject>
		<LabeledObject>
			<template #label>
				<i class="fa-solid fa-arrows-alt-h"/>
				{{ trans('certificate.modules.props.width') }}
			</template>
			<input v-model="module.w" type="number" min="30" step="1" :max="maxWidth">
		</LabeledObject>
		<LabeledObject>
			<template #label>
				<i class="fa-solid fa-arrows-alt-v"/>
				{{ trans('certificate.modules.props.height') }}
			</template>
			<input v-model="module.h" type="number" min="30" step="1" :max="maxHeight">
		</LabeledObject>
		<SecondaryButton :color="Color.Red" @click.stop="emit('deleteModule')">
			<i class="fa-solid fa-trash"/>
		</SecondaryButton>
	</div>
</template>
<script setup lang="ts">
import {type Ref, ref} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import FileManager from '@/Components/Files/FileManager.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {CertificateAlignment} from '@/Types/Enums/CertificateAlignment'
import {type CertificateModule} from '@/Types/Certificates/CertificateModule'

const props = defineProps<{
	maxWidth:number,
	maxHeight:number,
	modelValue:CertificateModule,
}>()

const maxWidth:Ref<number> = ref(props.maxWidth)
const maxHeight:Ref<number> = ref(props.maxHeight)
const showFileManager:Ref<boolean> = ref(false)
const module:Ref<CertificateModule> = ref(props.modelValue)

const emit = defineEmits([
	'deleteModule',
	'stopEditing',
])
</script>
